import '../../../scss/forms.scss';
import '../../../scss/modal.scss';
// import "./_style.scss";

import React from 'react';

import {
  Row, Col, Card, CardHeader, CardBody, Button, Modal, ModalBody, ModalHeader, ModalFooter,
} from 'reactstrap';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as RecepcionarActions from '../../../store/ducks/protocolo/recepcao/recepcionar/actions';

import DynamicForm from '../../DynamicForm';
import warning from '../../../assets/img/brand/warning.svg';
import { redirectHandled } from '../../../util/helper';

class Recepcionar extends React.Component {
  constructor(props) {
    super(props);

    let match = this.props.location.pathname ? this.props.location.pathname.split('/') : '';
    let _page = `/recepcao/recepcao-contrato/`;


    this.state = {
      url: _page.replace('//', '/'),
      fields: [
        {
          name: 'protocolo',
          type: 'number',
          placeholder: 'Protocolo',
          label: 'Protocolo',
          sizeSm: 2,
          sizeMd: 4,
          sizeLg: 3,
          value: '',
        },
      ],
    };

    this.pesquisar = this.pesquisar.bind(this);
    this.toggleProtocoloRecepcionado = this.toggleProtocoloRecepcionado.bind(this);
  }

  componentDidMount() {
    this.props.actions.clear();
  }

  componentDidUpdate() {
    /* Redirect para recepcao protocolos */
    if (this.props.recepcionar.redirecionarParaPaginaProtocoloRecepcaoContrato) {
      const numero = this.props.recepcionar.protocolo;
      redirectHandled(this.props.history, `${this.state.url}${numero}`)
    }
  }

  pesquisar(values) {
    const fields = {};
    if (values.protocolo) {
      fields.protocolo = values.protocolo;
    } else {
      fields.protocolo = '';
    }

    this.props.actions.searchRequest(fields.protocolo);
  }

  toggleProtocoloRecepcionado() {
    this.props.actions.clear();
  }

  render() {
    return (
      <Row>
        <Modal isOpen={this.props.recepcionar.modalProtocoloRecepcionado} toggle={this.toggleProtocoloRecepcionado} className="modal-md modal-default">
          <ModalHeader toggle={this.toggleProtocoloRecepcionado}>Informação</ModalHeader>
          <ModalBody>
            <div className="container-image">
              <img className="alert" src={warning} alt="alerta" />
            </div>
            <p className="text-alert error">O protocolo informado já foi recepcionado</p>
          </ModalBody>
          <ModalFooter>
            <Button className="btn_success" onClick={this.toggleProtocoloRecepcionado}>Fechar</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.props.recepcionar.numeroInvalidoProtocolo} toggle={this.toggleProtocoloRecepcionado} className="modal-md modal-default">
          <ModalHeader toggle={this.toggleProtocoloRecepcionado}>Informação</ModalHeader>
          <ModalBody>
            <div className="container-image">
              <img className="alert" src={warning} alt="alerta" />
            </div>
            <p className="text-alert error">O número do protocolo informado não é válido</p>
          </ModalBody>
          <ModalFooter>
            <Button className="btn_success" onClick={this.toggleProtocoloRecepcionado}>Fechar</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.props.recepcionar.modalProtocoloExcluido} toggle={this.toggleProtocoloRecepcionado} className="modal-md modal-default">
          <ModalHeader toggle={this.toggleProtocoloRecepcionado}>Informação</ModalHeader>
          <ModalBody>
            <div className="container-image">
              <img className="alert" src={warning} alt="alerta" />
            </div>
            <p className="text-alert error">O número do protocolo informado não é válido</p>
          </ModalBody>
          <ModalFooter>
            <Button className="btn_success" onClick={this.toggleProtocoloRecepcionado}>Fechar</Button>
          </ModalFooter>
        </Modal>

        <Col sm={8} md={12} style={{ flexBasis: 'auto' }}>
          <Card>
            <CardHeader>
              <strong>Recepção</strong>
              {' '}
            </CardHeader>
            <CardBody>
              <DynamicForm ref="form" fields={this.state.fields} classRow="mt-2" onSubmit={this.pesquisar}>
                <Col sm={6} md={2} lg={1} className="col-6 d-flex justify-content-center align-items-center">
                  <Button color="secondary" type="submit">
                    Pesquisar
                  </Button>
                </Col>
              </DynamicForm>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  recepcionar: state.recepcaoReducer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(RecepcionarActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Recepcionar);
